import { combineReducers } from 'redux';
import GA from '../plugins/GA/reducers';
export default combineReducers({ GA });


// WEBPACK FOOTER //
// ./D:/Repos/university/my-composer/app/reducers/index.js